import React, { forwardRef } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  icon,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full flex flex-col gap-1.5" data-id="element-200">
        {label && <label className="text-sm font-medium text-softGray ml-1" data-id="element-201">
            {label}
          </label>}
        <div className="relative" data-id="element-202">
          {icon && <div className="absolute left-4 top-1/2 -translate-y-1/2 text-softGray" data-id="element-203">
              {icon}
            </div>}
          <input ref={ref} className={`w-full bg-surface border border-border rounded-xl px-4 py-3.5 text-white placeholder:text-softGray focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-colors ${icon ? 'pl-11' : ''} ${error ? 'border-neonOrange focus:border-neonOrange focus:ring-neonOrange' : ''} ${className}`} {...props} data-id="element-204" />
        </div>
        {error && <span className="text-xs text-neonOrange ml-1" data-id="element-205">{error}</span>}
      </div>;
});
Input.displayName = 'Input';